
    /**
     * @description
     *  Modelo de un identificador de job asincrónico.
     *
     * @see gigot-backend/Core/Persistence/Query/AsyncJobId.cs
     */

export class AsyncJobId {

    public jobId: string;
	public retrievalGuid: string;

    /**
     * @description
     *	Construye un ID de job asincrónico con una semántica vacía. Nótese que
	 *	no es lo mismo que construir un descuento con valores por defecto. Las
	 *	reglas generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un ID vacío.
     */
    public static empty(): AsyncJobId {
        const asyncJobId: AsyncJobId = new AsyncJobId();
		asyncJobId.jobId = "";
		asyncJobId.retrievalGuid = "";
		return asyncJobId;
    }

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicAsyncJobId
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
	public static from(anemicAsyncJobId: AsyncJobId): AsyncJobId {
		if (!anemicAsyncJobId) return undefined;
        const asyncJobId: AsyncJobId = AsyncJobId.empty();
		asyncJobId.jobId = anemicAsyncJobId.jobId;
		asyncJobId.retrievalGuid = anemicAsyncJobId.retrievalGuid;
		return asyncJobId;
	}
}
